import { BackButton } from 'components';
import React from 'react';

interface Props {
  children?: any;
  backLabel?: string;
  backUrl?: string;
  title?: string | React.ReactNode;
  actions?: React.ReactNode;
  onBackAction?: () => void;
  hideBackButton?: boolean;
}

const PageSubheader = (props: Props) => (
  <div className="PageSubheader">
    <div className="PageSubheader_inner">
      <div className="PageSubheader_top">
        {!props.hideBackButton && (
          <BackButton
            backUrl={props.backUrl || '/'}
            backLabel={props.backLabel}
            onBackAction={props.onBackAction}
          />
        )}
        {props.title && <div className="PageSubheader_title">{props.title}</div>}
        {props.actions && <div className="PageSubheader_actions">{props.actions}</div>}
      </div>
      <div className="PageSubheader_menu">{props.children}</div>
    </div>
  </div>
);

export default PageSubheader;
